
/**
 * @export
 * @enum {string}
 */
export enum PasswordSharingEventSource {
    EXCEL_PLUGIN = 'EXCEL_PLUGIN',
    MOBILE = 'MOBILE'
}